export const depressionThoughtsPt = [
  "Não sou bom o suficiente.",
  "Nada do que eu faço faz diferença.",
  "Sou um peso para os outros.",
  "Nunca vou melhorar.",
  "Não consigo fazer nada direito.",
  "As pessoas estariam melhor sem mim.",
  "Não tenho valor.",
  "Estou completamente sozinho.",
  "Não sinto vontade de fazer nada.",
  "As coisas sempre dão errado para mim.",
  "Não vejo sentido em nada.",
  "Sou um fracasso.",
  "Não consigo lidar com a vida.",
  "Não importa o quanto eu tente, não adianta.",
  "Não mereço coisas boas.",
  "Não estou no controle da minha vida.",
  "Não aguento mais sentir isso.",
  "Não confio em mim mesmo para lidar com o que vem.",
  "Todo mundo está melhor do que eu.",
  "As coisas nunca vão mudar.",
  "Estou falhando o tempo todo.",
  "Sou uma decepção.",
];

export const anxietyThoughtsPt = [
  "Algo ruim vai acontecer.",
  "Não vou conseguir lidar com isso.",
  "As pessoas vão me julgar.",
  "E se eu falhar?",
  "Tenho que ter certeza antes de agir.",
  "E se eu perder o controle?",
  "Tenho que estar preparado para o pior.",
  "Não posso errar.",
  "Se eu não ficar atento, algo ruim vai acontecer.",
  "As coisas vão sair do meu controle.",
  "Preciso agradar todo mundo.",
  "Se eu relaxar, algo vai dar errado.",
  "Não estou seguro.",
  "Não consigo confiar em mim mesmo.",
  "Qualquer pequeno erro pode ser um desastre.",
  "Não estou no controle da minha vida.",
  "Não aguento mais sentir isso.",
  "Não confio em mim mesmo para lidar com o que vem.",
  "Todo mundo está melhor do que eu.",
  "As coisas nunca vão mudar.",
  "Estou falhando o tempo todo.",
  "Sou uma decepção.",
  "Não estou no controle da minha vida.",
  "Não aguento mais sentir isso.",
  "Não confio em mim mesmo para lidar com o que vem.",
  "Todo mundo está melhor do que eu.",
  "As coisas nunca vão mudar.",
  "Estou falhando o tempo todo.",
  "Sou uma decepção.",
];
